module.exports = __webpack_public_path__ + "img/masodikbek.c473f334.svg";